import _ from 'lodash'

import CONSTANTS from 'core/data-model/constants/values'

import { isNil, isNotNil } from 'core/service/lib/type-check'
import { createSelector } from 'reselect'
import { getSelectedDisplayProduct, getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'
import { canProceedToCoveragePlan } from 'quick-quote/selectors/next-tab-proceeding'
import DEFAULTS from 'core/data-model/constants/defaults'

import {
  getSumAssured$,
  getSelectedRiders,
  getBasicPremium$,
  getTotalPremium$,
  getBasicPlanErrorMessage,
} from 'quick-quote/product-common/coverage-plan/selectors'

export const canProceedToBenefitIllustration = createSelector(
  getSumAssured$,
  getBasicPremium$,
  getTotalPremium$,
  getBasicPlanErrorMessage,
  getSelectedRiders,
  canProceedToCoveragePlan,
  getSelectedDisplayProduct,
  (
    sumAssured$,
    basicPremium,
    totalPremium$,
    basicPlanErrorMessage,
    selectedRiders,
    canProceedToCoveragePlan,
    selectedDisplayProduct
  ) => {
    const selectedRiderInvalidMessages = selectedRiders.filter((rider) =>
      isNotNil(rider.errors.find((error) => error.type === CONSTANTS.VALIDATION))
    )

    const canProceed =
      canProceedToCoveragePlan &&
      sumAssured$.isOk &&
      basicPremium.isOk &&
      totalPremium$.isOk &&
      _.isEmpty(selectedRiderInvalidMessages) &&
      _.isEmpty(basicPlanErrorMessage)
    if (selectedDisplayProduct.type === CONSTANTS.CAMPAIGN_PRODUCT_TYPE) {
      const selectedRiderCodes = selectedRiders.map((rider) => rider.code)
      return (
        canProceed &&
        selectedDisplayProduct.requiredRiders != null &&
        selectedDisplayProduct.requiredRiders.every((riderCode) => {
          return selectedRiderCodes.indexOf(riderCode) > -1
        })
      )
    }
    return canProceed
  }
)

export const getSelectedProductLifeReady = createSelector(getSelectedDisplayProductCode, (productCode) => {
  switch (productCode) {
    case DEFAULTS.DEFAULT_LIFE_READY_18_YEAR_HIGHER:
    case DEFAULTS.DEFAULT_LIFE_READY_18_YEAR_CAMPAIGN_UNDER:
    case DEFAULTS.DEFAULT_LIFE_READY_18_YEAR_CAMPAIGN_HIGHER:
      return DEFAULTS.DEFAULT_LIFE_READY_18_YEAR_UNDER
    case DEFAULTS.DEFAULT_LIFE_READY_99_YEAR_HIGHER:
      return DEFAULTS.DEFAULT_LIFE_READY_99_YEAR_UNDER
    default:
      return productCode
  }
})

export const getSelectedProductRokeRaiSoShield = createSelector(getSelectedDisplayProductCode, (productCode) => {
  switch (productCode) {
    case DEFAULTS.DEFAULT_ROKE_RAI_SO_SHIELD_W99FH18:
      return DEFAULTS.DEFAULT_ROKE_RAI_SO_SHIELD_W99FU18
    case DEFAULTS.DEFAULT_ROKE_RAI_SO_SHIELD_W99FH99:
      return DEFAULTS.DEFAULT_ROKE_RAI_SO_SHIELD_W99FU99
    default:
      return productCode
  }
})

export const getSelectedProductCICombo = createSelector(getSelectedDisplayProductCode, (productCode) => {
  switch (productCode) {
    case DEFAULTS.DEFAULT_CI_COMBO_W99FH18:
      return DEFAULTS.DEFAULT_CI_COMBO_W99FU18
    case DEFAULTS.DEFAULT_CI_COMBO_W99FH99:
      return DEFAULTS.DEFAULT_CI_COMBO_W99FU99
    default:
      return productCode
  }
})

export const getSelectedProductHealthCombo = createSelector(getSelectedDisplayProductCode, (productCode) => {
  switch (productCode) {
    case DEFAULTS.DEFAULT_HEALTH_COMBO_W99FH18:
      return DEFAULTS.DEFAULT_HEALTH_COMBO_W99FU18
    case DEFAULTS.DEFAULT_HEALTH_COMBO_W99FH99:
      return DEFAULTS.DEFAULT_HEALTH_COMBO_W99FU99
    default:
      return productCode
  }
})
